define(function (require) {

    var BaseConnectionsEngagementWidget = require('web-agent-widgets/BaseConnectionsEngagementWidget');

    var AppConnectionsEngagementWidget = BaseConnectionsEngagementWidget.extend({
        ControllerName: "AppConnectionsEngagementWidget",
        applicationType: "AppConnectionsEngagementWidget",

        initialize: function (options) {
            this.logic = lpTag.WebAgent.logicController;
        }
    });

    AppConnectionsEngagementWidget.prototype.onEngagementSelected = function (engagementId) {
        BaseConnectionsEngagementWidget.prototype.onEngagementSelected.call(this, engagementId);

        if (engagementId) {

            lpTag.WebAgent.amsMessagesController.queryMessages(engagementId);

            // check if logged in agent is participating in the conversation - if so, we already are getting notifications,
            // so no need to participate again as a reader
            var dialogId = this.logic.getActiveDialogIdOfConversation(engagementId);
            var roleInConversationDialog = this.logic.getLoggedInAgentRoleInConversationDialog(engagementId, dialogId);
            if (dialogId && !roleInConversationDialog) {
                this.modelController.addReaderParticipant({
                    conversationId: engagementId,
                    dialogId: dialogId,
                    success: function () {
                        this.logic.setLoggedInAgentPeekerParticipant(engagementId, dialogId, true);
                    },
                    context: this
                });
            }
        }
    };

    AppConnectionsEngagementWidget.prototype.onEngagementCleared = function (engagementId) {
        BaseConnectionsEngagementWidget.prototype.onEngagementCleared.call(this, engagementId);

        if (engagementId && !this.logic.isMyChat(engagementId)) {
            var dialogId = this.logic.getActiveDialogIdOfConversation(engagementId);
            if (dialogId && this.logic.isLoggedInAgentPeekerParticipant(engagementId, dialogId)) {
                // testing inMyEngagements to avoid removing reader when widget is open and clicking the consumer link to
                // open the engagement. in such case the reader participant will be added before the widget is closed
                // and this function will wrongfully remove it.
                if (this.logic.isInMyEngagements(engagementId)) {
                    this.logic.setLoggedInAgentPeekerParticipant(engagementId, dialogId, false);
                } else {
                    this.modelController.removeReaderParticipant({
                        conversationId: engagementId,
                        dialogId: dialogId,
                        success: function () {
                            this.logic.setLoggedInAgentPeekerParticipant(engagementId, dialogId, false);
                        },
                        context: this
                    });
                }
            }
        }
    };

    return AppConnectionsEngagementWidget;

});
